import React, { useRef, useState } from "react";
import Dropdown, { DropdownProps } from "./Dropdown";
import Button from "./Button";
import CustomCalendar from "./CalendarComp.js/Calendar";
import moment from "moment";

const dateFilterOptions = [
    {
        label: "This year",
        value: "yearly",
    },

    {
        label: "This month",
        value: "monthly",
    },

    {
        label: "Custom",
        value: "custom",
    },
];

export type DateFilter = {
    handleChange?: (
        name: string,
        value: { period: string; startDate: string; endDate: string }
    ) => void;
} & DropdownProps;

export default function DateField(props: DateFilter) {
    const { handleChange, ...rest } = props;

    const [openCustomDate, setOpenCustomDate] = useState(false);
    const [dateFilter, setDateFilter] = useState({
        period: "yearly",
        startDate: "",
        endDate: "",
    });
    const customRef = useRef(null);

    const handleDateChange = (e) => {
        const { value, name } = e.target;
        console.log({ value, name });
        setDateFilter((prev) => ({
            ...prev,
            period: value,
            ...(value !== "custom" && {
                startDate: "",
                endDate: "",
            }),
        }));

        value === "custom" && setOpenCustomDate(true);

        handleChange?.(name, {
            ...dateFilter,
            period: value,
        });
    };

    return (
        <div>
            <div className="">
                <Dropdown
                    handleChange={(name, value) => {
                        handleDateChange({ target: { name, value } });
                    }}
                    dropdown={
                        <div className="flex items-center justify-between rounded-[6px]  py-[6px] px-[10px] gap-2 !border !border-slate-200 max-sm:hidden">
                            <div
                                className={`text-g-75 font-rocGroteskMedium text-[13px] whitespace-nowrap truncate inline-block ${
                                    dateFilter?.period === "custom" && "capitalize"
                                } `}
                            >
                                {dateFilter?.startDate && dateFilter?.endDate
                                    ? ` ${moment(dateFilter?.startDate).format(
                                          "DD-MMM-YYYY"
                                      )} to ${moment(dateFilter?.endDate).format("DD-MMM-YYYY")}`
                                    : dateFilterOptions?.find(
                                          (item) => item.value === dateFilter?.period
                                      )?.label || "This year"}
                            </div>

                            <i className="ri-arrow-down-s-line text-lg text-[#142837]"></i>
                        </div>
                    }
                    dropdownItemsClasses="!px-0 !py-0"
                    dropdownClassName="!w-full !mb-10 !-mt-7"
                    dropdownContainerClasses={`shadow-cardShadow-4 border border-slate-100 right-0 rounded-[6px] !max-h-fit !w-auto`}
                    name="valueRange"
                    dropdownOptions={[
                        ...dateFilterOptions?.map((item, idx) => ({
                            label: (
                                <div
                                    key={idx}
                                    className={`${
                                        item.value === "custom" && "capitalize"
                                    } text-g-75 font-rocGroteskMedium text-[13px] flex justify-between
                            border-b border-b-slate-100 !w-[120px] px-4 py-[10px]`}
                                >
                                    {item?.label}
                                </div>
                            ),
                            value: item?.value,
                        })),
                    ]}
                    {...rest}
                />
            </div>

            <div className="relative">
                {openCustomDate && (
                    <div
                        ref={customRef}
                        className="w-[630px]  z-[10000] absolute  right-0 top-16 px-[28px] pt-8 pb-8 bg-white
                        rounded-2xl shadow-[0px_0px_4px_rgba(0,0,0,0.04),0px_4px_32px_rgba(0,0,0,0.06)]"
                    >
                        <CustomCalendar
                            showDoubleView={true}
                            selectRange={true}
                            value={[dateFilter?.startDate, dateFilter?.endDate]}
                            onChange={(value) => {
                                setDateFilter((prev) => ({
                                    ...prev,
                                    startDate: value[0],
                                    endDate: value[1],
                                }));
                                handleChange?.("dateRange", {
                                    ...dateFilter,
                                    startDate: value[0],
                                    endDate: value[1],
                                });
                            }}
                        />
                        <div className="flex justify-end">
                            <Button
                                btnText={"Close"}
                                btnClassname={"!w-fit !py-2"}
                                onClick={() => setOpenCustomDate(false)}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
